import { IProfileActionService, PROFILE_ACTION } from "../IProfileActionService";
import { Injectable } from "@angular/core";
import {
  Serializer,
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { Observable, Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class ProfileReplicaActionService implements IProfileActionService {
  protected VALUE: CubiqTS.ConcreteEncodable;
  protected broker: ClientMessageBroker;
  protected _serializer: Serializer = new CubiqTS.CubiqSerializer();

  protected _updateSubjectMap = new Map<string, Set<Subject<string>>>();

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.broker = this.factory.createMessageBroker(PROFILE_ACTION, true, true);
    this.VALUE = CubiqTS.ENCODABLE(CubiqTS.ProfileUpdateRequestImpl);
  }

  private createProfileConfigUpdateChannel(settingKey: string) {
    // create a single message channel per profileSettingKey
    let mc = new MessageChannel();
    let rp: MessagePort = mc.port1;
    let pp: MessagePort = mc.port2;

    let request = new UiArguments("registerReplicaUpdateSubject", [
      new FnArg(settingKey, PRIMITIVE),
      new FnTransferableArg(pp, PRIMITIVE),
    ]);

    this._updateSubjectMap.set(settingKey, new Set());

    rp.addEventListener("message", (event: any) => {
      if (
        event == Object(event) &&
        event.data == Object(event.data) &&
        event.data.profileValue == Object(event.data.profileValue) &&
        typeof event.data.profileValue === "string"
      ) {
        this._updateSubjectMap.get(settingKey).forEach((subject) => {
          subject.next(event.data.profileValue);
        });
      } else {
        logger.out.error(`ProfileReplicaActionService: failed to decode remote ${event}`);
      }
    });

    rp.start();

    this.broker.runOnService(request, null);
  }

  getProfileConfigUpdates(profileSettingKey: string): Observable<string> {
    let subject = new Subject<string>();

    if (!this._updateSubjectMap.has(profileSettingKey)) {
      this.createProfileConfigUpdateChannel(profileSettingKey);
    }

    this._updateSubjectMap.get(profileSettingKey).add(subject);

    return subject.asObservable();
  }

  updateProfile(
    propfileSettings: Array<CubiqTS.ProfileSettingImpl>,
    isUserSettings: boolean,
  ): Promise<void> {
    let request = new UiArguments("updateProfile");
    let arg1 = new FnArg(propfileSettings, PRIMITIVE);
    let arg2 = new FnArg(isUserSettings, PRIMITIVE);
    request.args = [arg1, arg2];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getProfileConfig(profileSettingKey: string) {
    let request = new UiArguments("getProfileConfig");
    let arg1 = new FnArg(profileSettingKey, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  getProfileSettings(): Promise<any> {
    let request = new UiArguments("getProfileSettings");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  createUserSettingsProfileUpdateRequest(): Promise<CubiqTS.ProfileUpdateRequestImpl> {
    let request = new UiArguments("createUserSettingsProfileUpdateRequest");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  isPrimed(): Promise<boolean> {
    let request = new UiArguments("isPrimed");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
